import axios from "../axios";

export default {
    queryManufactureType(inOpts){
        return axios.request({
            cmd:'product/queryManufactureType',
            data:inOpts,
        })
    },
    queryManufacture(inOpts){
        return axios.request({
            cmd:'product/queryManufacture',
            data:inOpts,
        })
    },
    queryProductByType(inOpts){
        return axios.request({
            cmd:'product/queryProductByType',
            data:inOpts,
        })
    },
    queryProduct(inOpts){
        return axios.request({
            cmd:'product/queryProduct',
            date:inOpts
        })
    }
}